import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import TextGradient from "@app/components/gradient/gradient-text"
import { useState } from "react";

const MobileOfficeMixedUse = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="px-8 pt-8 pb-4 bg-background-mid-em lg:-mt-2">
      <div className="flex flex-col space-y-5 ">
      <TextGradient>
            <span className="h2">06</span>
          </TextGradient>
        <p className="mobile-h3 2xs:mobile-h2 text-background-primary-dark">
          Office & Mixed Use
        </p>
        <GradientContainer overrideClassName="w-[30%] h-2" />
        <div className="text-text-color-mid-em-light space-y-5">
          <p>
            SimpleWaste represents offices and mixed-use building environments.
            Our unique service and technology platform are customized to accommodate
            single tenants or property management groups.
          </p>
          <p>
            Through our technology platform clients are able secure cost
            reduction with ease-of-use vendor management across all 50 states.
          </p>
          {isExpanded && (
            <div className="space-y-5">
              <p>
                Reduce your property refuse and utility costs through our aggregate purchasing model.
              </p>
              <p className="lg:hidden xl:block">
                With the RFP Optimizer you&apos;ll be able to automate bids, select preferred vendors,
                and manage services at a property by property basis.
                Vendor updates and communication are recorded and tracked within the technology platform,
                giving your management team access to LIVE data with 100% visibility.
              </p>
            </div>
          )}
        </div>
        <div>
          <Button onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? 'Read less' : 'Read more'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileOfficeMixedUse;